import React, {Component} from "react";  import config from 'react-global-configuration';
import {Line} from 'react-chartjs-2';
import axios from "axios";
import jwt_decode from "jwt-decode";
import Select from 'react-select';
import {css} from "@emotion/core";
import $ from "jquery";
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import * as moment from "moment";
import {BeatLoader} from "react-spinners";
import loadingGif from "../assets/img/loading.gif";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { List } from 'react-virtualized';
import {connect}  from  "react-redux";

var todayDate = new Date();
var yesterday = new Date(Date.now() - 24*60*60*1000);
var tod = moment(todayDate).format('MM/DD/YYYY');
var yest = moment(yesterday).format('MM/DD/YYYY');
var todShow = moment(todayDate).format('D MMM YYYY');
var yestShow = moment(yesterday).format('D MMM YYYY');
var todSend = moment(todayDate).format('YYYY-MM-DD');
var yestSend = moment(yesterday).format('YYYY-MM-DD');
const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;


function  generateData() {
    //alert("dasdad");
}

var toolTipConfig = {
    // Disable the on-canvas tooltip
    enabled: false,

    custom: function(tooltipModel) {
        // Tooltip Element
        var tooltipEl = document.getElementById('chartjs-tooltip');
        // Create element on first render
        if (!tooltipEl) {
            tooltipEl = document.createElement('div');
            tooltipEl.id = 'chartjs-tooltip';
            tooltipEl.innerHTML = '<table class="lineChartTooltip"></table>';
            document.body.appendChild(tooltipEl);
        }
        // Hide if no tooltip
        if (tooltipModel.opacity === 0) {
            tooltipEl.style.opacity = 0;
            return;
        }
        // Set caret Position
        tooltipEl.classList.remove('above', 'below', 'no-transform');
        if (tooltipModel.yAlign) {
            tooltipEl.classList.add(tooltipModel.yAlign);
        } else {
            tooltipEl.classList.add('no-transform');
        }
        function getBody(bodyItem) {
            return bodyItem.lines;
        }
        // Set Text
        if (tooltipModel.body) {
            var titleLines = tooltipModel.title || [];
            var bodyLines = tooltipModel.body.map(getBody);
            var innerHtml = '<thead>';
            titleLines.forEach(function(title) {
                innerHtml += '<tr><th>' + title + '</th></tr>';
            });
            innerHtml += '</thead><tbody>';
            bodyLines.forEach(function(body, i) {
                var colors = tooltipModel.labelColors[i];
                var style = 'background:' + colors.backgroundColor;
                style += '; border-color:' + colors.borderColor;
                style += '; border-width: 2px';
                var styleColor = '; color: #FFFFFF';
                var span = '<span style="' + style + '"></span>';
                innerHtml += '<tr><td style="' + styleColor + '">' + span + body + '</td></tr>';
            });
            innerHtml += '</tbody>';
            var tableRoot = tooltipEl.querySelector('table');
            tableRoot.innerHTML = innerHtml;
        }

        // `this` will be the overall tooltip
        var position = this._chart.canvas.getBoundingClientRect();

        // Display, position, and set styles for font
        tooltipEl.style.opacity = 1;
        tooltipEl.style.position = 'absolute';
        tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
        tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
        tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
        tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px';
        tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
        tooltipEl.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';
        tooltipEl.style.pointerEvents = 'none';
    }
};

function formatNumber (num) {
    //return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
    var n1, n2;
    num = num + '' || '';
    // works for integer and floating as well
    n1 = num.split('.');
    n2 = n1[1] || null;
    n1 = n1[0].replace(/(\d)(?=(\d\d)+\d$)/g, "$1,");
    num = n2 ? n1 + '.' + n2 : n1;
    return num;
}
function getMonth(date) {
    var month = date.getMonth() + 1;
    return month < 10 ? '0' + month : '' + month; // ('' + month) for string result
}
const monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
];
var monthDefault = [];
let dateDefault = new Date();
let monthd = dateDefault.setMonth(dateDefault.getMonth() -1);
dateDefault = dateDefault.toDateString();
dateDefault = new Date(dateDefault);
let monthDefaults = getMonth(dateDefault);
let yearDefault= dateDefault.getFullYear();
let monthNamed = monthNames[dateDefault.getMonth()];
monthDefault.push({ value: monthDefaults+yearDefault, label: monthNamed+' '+yearDefault});

class AcquirerReport extends Component {
    state= {
        loading: true,
        loading1: true,
        merchantList:[],
        chainList:[],
        merchantID:'',
        chainID:'',
        storeID:'',
        merchantValue:null,
        chainValue:null,
        storeList:[],
        acqBankList:[],
        acqBankValue: null,
        acqBankIds:'',
        issuerBankList:[],
        issuerBankValue:null,
        issuerBankIds:'',
        cityLists:[],
        cityValue:null,
        cityIds:'',
        stateLists:[],
        stateValue:null,
        stateIds:'',
        dateTo:tod,
        dateToShow:todShow,
        todSend:todSend,
        yestSend:yestSend,
        datefrom:yest,
        datefromShow:yestShow,
        t_type: 'percentage',
        inno_transaction_vol:0,
        acq_transaction_vol:0,
        inno_transaction_vol_credit:0,
        acq_transaction_vol_credit:0,
        inno_transaction_vol_dcc:0,
        acq_transaction_vol_dcc:0,
        inno_transaction_vol_upi:0,
        acq_transaction_vol_upi:0,
        inno_transaction_vol_debit:0,
        acq_transaction_vol_debit:0,
        inno_store_count:0,
        acq_store_count:0,
        defaultBank:[],
        count_per:0,
        debit_per:0,
        credit_per:0,
        dcc_per:0,
        upi_per:0,
        vol_per:0,
        is_view_report:false,
        is_view_kpi:false,
        loading3:true,
        is_merchant_vol: true,
        is_merchant_per: true,
        is_vol: true,
        is_vol_per: true,
        is_credit_vol: true,
        is_credit_vol_per: true,
        is_debit_vol: true,
        is_debit_vol_per: true,
        is_upi_vol: true,
        is_upi_vol_per: true,
        is_dcc_vol: true,
        is_dcc_vol_per: true,


    };
      componentWillMount() {
        this.props.currentMenu("unipaynext");
        }
    componentDidMount() {
        generateData();
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        // this.getInvoiceMonth();
        // this.getInvoiceMonthly(this.state.invoice_month);
        // this.get_notifications(decoded);
        //this.get_invoice_history();

        this._getAllMerchants();
        this._get_acq_banks();
        this._get_states();
        this._get_city('');
        //this._get_filtered_acq_report();
       // this._get_acq_report(this.state.yestSend, this.state.todSend, '');
        //this._get_acq_banks();


        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: decoded.object_code,
        });
        this.getChain(decoded.object_code, 'innoviti', decoded.object_type, decoded.object_code);
        this.getStore(decoded.object_code, 'innoviti', decoded.object_type, decoded.object_code);
    }

    _get_acq_report(start, end, bankID){
        this.setState({
            loading1:true,
            is_view_report:false,
        });
        axios.post(config.get('API_URL')+'/reports/get-acq-reports/',{
                yestSend:  start,
                todSend:  end,
                // "yestSend": "2020-01-11",
                // "todSend": "2020-01-16",
                acquirer_bank_code: bankID,
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

            }).then(response => {
            var inno_transaction_vol=0; var acq_tra_vol = 0;
            var inno_transaction_vol_credit=0; var acq_tra_vol_credit = 0;
            var inno_transaction_vol_dcc=0; var acq_tra_vol_dcc = 0;
            var inno_transaction_vol_upi=0; var acq_tra_vol_upi = 0;
            var inno_transaction_vol_debit=0; var acq_tra_vol_debit = 0;
            var inno_transaction_vol_count=0; var acq_tra_vol_count = 0;
            var count_per = 0;
            var debit_per = 0;
            var credit_per = 0;
            var dcc_per = 0;
            var upi_per = 0;
            var vol_per = 0;
            if(Array.isArray(response.data.data) && response.data.data.length) {
                if ('transaction_volume' in response.data.data[0].innoviti) {
                    inno_transaction_vol = response.data.data[0].innoviti.transaction_volume
                }
                if ('transaction_volume' in response.data.data[1].acq_bank) {
                    acq_tra_vol = response.data.data[1].acq_bank.transaction_volume
                }
                if ('transaction_volume_credit' in response.data.data[0].innoviti) {
                    inno_transaction_vol_credit = response.data.data[0].innoviti.transaction_volume_credit
                }
                if ('transaction_volume_credit' in response.data.data[1].acq_bank) {
                    acq_tra_vol_credit = response.data.data[1].acq_bank.transaction_volume_credit
                }
                if ('transaction_volume_emi' in response.data.data[0].innoviti) {
                    inno_transaction_vol_dcc = response.data.data[0].innoviti.transaction_volume_emi
                }
                if ('transaction_volume_emi' in response.data.data[1].acq_bank) {
                    acq_tra_vol_dcc = response.data.data[1].acq_bank.transaction_volume_emi
                }
                if ('transaction_volume_upi' in response.data.data[0].innoviti) {
                    inno_transaction_vol_upi = response.data.data[0].innoviti.transaction_volume_upi
                }
                if ('transaction_volume_upi' in response.data.data[1].acq_bank) {
                    acq_tra_vol_upi = response.data.data[1].acq_bank.transaction_volume_upi
                }
                if ('transaction_volume_upi' in response.data.data[0].innoviti) {
                    inno_transaction_vol_upi = response.data.data[0].innoviti.transaction_volume_upi
                }
                if ('transaction_volume_upi' in response.data.data[1].acq_bank) {
                    acq_tra_vol_upi = response.data.data[1].acq_bank.transaction_volume_upi
                }
                if ('transaction_volume_debit' in response.data.data[0].innoviti) {
                    inno_transaction_vol_debit = response.data.data[0].innoviti.transaction_volume_debit
                }
                if ('transaction_volume_debit' in response.data.data[1].acq_bank) {
                    acq_tra_vol_debit = response.data.data[1].acq_bank.transaction_volume_debit
                }
                if ('total_store_count' in response.data.data[0].innoviti) {
                    inno_transaction_vol_count = response.data.data[0].innoviti.total_store_count
                }
                if ('total_store_count_for_acq_bank' in response.data.data[1].acq_bank) {
                    acq_tra_vol_count = response.data.data[1].acq_bank.total_store_count_for_acq_bank

                }
                credit_per = parseInt(acq_tra_vol_credit)*100/parseInt(inno_transaction_vol_credit);
                debit_per = parseInt(acq_tra_vol_count)*100/parseInt(inno_transaction_vol_count);
                dcc_per = parseInt(acq_tra_vol_dcc)*100/parseInt(inno_transaction_vol_dcc);
                upi_per = parseInt(acq_tra_vol_upi)*100/parseInt(inno_transaction_vol_upi);
                vol_per = parseInt(acq_tra_vol)*100/parseInt(inno_transaction_vol);
                count_per = parseInt(acq_tra_vol_count)*100/parseInt(inno_transaction_vol_count);
                credit_per=credit_per?credit_per.toFixed(2):0;
                debit_per=debit_per?debit_per.toFixed(2):0;
                dcc_per=dcc_per?dcc_per.toFixed(2):0;
                upi_per=upi_per?upi_per.toFixed(2):0;
                vol_per=vol_per?vol_per.toFixed(2):0;
                count_per=count_per?count_per.toFixed(2):0;
            }
            this.setState({
                inno_transaction_vol:inno_transaction_vol,
                acq_transaction_vol:acq_tra_vol,
                inno_transaction_vol_credit:inno_transaction_vol_credit,
                acq_transaction_vol_credit:acq_tra_vol_credit,
                inno_transaction_vol_dcc:inno_transaction_vol_dcc,
                acq_transaction_vol_dcc:acq_tra_vol_dcc,
                inno_transaction_vol_upi:inno_transaction_vol_upi,
                acq_transaction_vol_upi:acq_tra_vol_upi,
                inno_transaction_vol_debit:inno_transaction_vol_debit,
                acq_transaction_vol_debit:acq_tra_vol_debit,
                inno_store_count:inno_transaction_vol_count,
                acq_store_count:acq_tra_vol_count,
                count_per: count_per,
                vol_per: vol_per,
                upi_per: upi_per,
                dcc_per: dcc_per,
                debit_per: debit_per,
                credit_per: credit_per,
                is_view_report:true,
                loading1: false
            })
        });
    }
    get_merchant_small_chart(transaction_volume, transaction_volume_month, type){

        const data = {
            labels:transaction_volume_month,
            datasets: [
                {
                    label: type,
                    fill: false,
                    lineTension: 0.1,
                    borderWidth: 1,
                    backgroundColor: 'rgba(75,192,192,0.4)',
                    borderColor: 'rgba(75,192,192,1)',
                    borderCapStyle: 'butt',
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: 'miter',
                    pointBorderColor: 'rgba(75,192,192,1)',
                    pointBackgroundColor: '#fff',
                    pointBorderWidth: 1,
                    pointHoverRadius: 5,
                    pointHoverBackgroundColor: 'rgba(75,192,192,1)',
                    pointHoverBorderColor: 'rgba(220,220,220,1)',
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: transaction_volume
                }
            ]
        };
        // toolTipConfig = {
        //     callbacks: {
        //         title: function(tooltipItem, data) {
        //             return data['labels'][tooltipItem[0]['index']];
        //         },
        //         label: function(tooltipItem, data) {
        //             return data['datasets'][0]['data'][tooltipItem['index']];
        //         },
        //         afterLabel: function(tooltipItem, data) {
        //             var dataset = data['datasets'][0];
        //             var percent = 'K'
        //             return '(' + percent + '%)';
        //         }
        //     },
        //     backgroundColor: '#FFF',
        //     titleFontSize: 16,
        //     titleFontColor: '#0066ff',
        //     bodyFontColor: '#000',
        //     bodyFontSize: 14,
        //     displayColors: false
        // }
        if(type=='Merchant') {
            this.setState({
                merchant_chart_data: data
            })
        }
        if(type=='Volume') {
            this.setState({
                volume_chart_data: data
            })
        }
        if(type=='Credit Volume') {
            this.setState({
                cr_vol_chart_data: data
            })
        }
        if(type=='Debit Volume') {
            this.setState({
                deb_vol_chart_data: data
            })
        }
        if(type=='UPI Volume') {
            //.log(data);
            this.setState({
                upi_vol_chart_data: data
            })
        }
        if(type=='DCC Volume') {
            // console.log("emmm");
            // console.log(data);
            this.setState({
                dcc_vol_chart_data: data
            })
        }
    }

    handleEvent(event, picker, e) {
        this.setState({
            todSend: moment(picker.endDate).format('YYYY-MM-DD'),
            yestSend: moment(picker.startDate).format('YYYY-MM-DD'),
            datefromShow: moment(picker.startDate).format('D MMM YYYY'),
            dateToShow: moment(picker.endDate).format('D MMM YYYY')
        });
        if(event.type=='apply'){
            this._get_acq_report(moment(picker.startDate).format('YYYY-MM-DD'), moment(picker.endDate).format('YYYY-MM-DD'), this.state.acqBankIds);
            this._get_filtered_acq_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds,
                moment(picker.startDate).format('YYYY-MM-DD'), moment(picker.endDate).format('YYYY-MM-DD'), this.state.cityIds, this.state.stateIds);
        }
    }
    _getAllMerchants(){
        axios.get(config.get('API_URL')+'/reports/get-merchant/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            response.data.map((merchant,index) => {
                this.state.merchantList.push({value: merchant.merchant_code, label: merchant.merchant_name})
            });
        });
    }
    _get_filtered_acq_report(mids,cids,sids,bankID,fromdate,todate,cityids,stateIds){

        var postData = {
            mids: mids,
            cids: cids,
            sids: sids,
            yestSend: fromdate,
            todSend: todate,
            acquirer_bank_code: bankID,
            stateIds:stateIds,
            cityids: cityids,

        };
        if ($.fn.DataTable.isDataTable('#AcqReportVol')) {
            $('#AcqReportVol').DataTable().clear().destroy();
        }
        var AcqReportVol = $('#AcqReportVol').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : true,
                //"autoWidth": false,
                "responsive": false,
                // "scrollX": true,
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/reports/acq-reports-table",
                    type: "POST",
                    data: postData,
                    dataSrc: function (json) {
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                },

                columns: [
                    {"data":"Merchant"},
                    {"data":"Merchant Code"},
                    {"data":"Innoviti Store Count"},
                    {"data":"Bank Store Count"},
                    {"data":"Innoviti Terminal Count"},
                    {"data":"Bank Terminal Count"},
                    {"data":"Innoviti Card Volume"},
                    {"data":"Bank Card Volume"},
                    {"data":"Innoviti UPI Volume"},
                    {"data":"Bank UPI Volume"},
                    {"data":"Innoviti DCC Volume"},
                    {"data":"Bank DCC Volume"},
                ],
                "columnDefs": [
                    { "width": "20%",
                        render: function (data) {
                            return '<td ><div class="collapseFirstTD"><a href="#">'+data+'</a> </div></td>';
                        },
                        className: "summary_plus",
                        targets: 0,
                        aTargets: [ -1 ]
                    },
                    { "width": "10%",
                        render: function (data) {
                            return '<td >&nbsp;</td>';
                        },
                        targets: 1,
                        aTargets: [ -1 ]
                    },
                    { "width": "7%",
                        targets: 2,
                    },
                    { "width": "7%",
                        targets: 3,
                    },
                    { "width": "7%",
                        targets: 4,
                    },
                    { "width": "7%",
                        targets: 5,
                    },
                    { "width": "7%",
                        targets: 6,
                    },
                    { "width": "7%",
                        targets: 7,
                    },
                    { "width": "7%",
                        targets: 8,
                    },
                    { "width": "7%",
                        targets: 9,
                    },
                    { "width": "7%",
                        targets: 10,
                    },
                    { "width": "7%",
                        targets: 11,
                    }
                ]
            });

        $('#AcqReportVol').on('click', 'td', function(){
            var tr = $(this).closest('tr');
            var row = AcqReportVol.row( tr );
            if ( row.child.isShown() ) {
                // This row is already open - close it
                row.child.hide();
                tr.removeClass('shown');
                $(this).closest('tr').find('.summary_minus').addClass('summary_plus');
                $(this).closest('tr').find('.summary_minus').removeClass('summary_minus');
            }
            else {
                // Open this row
                if(row.data()!=undefined) {
                    var mcode = row.data()["Merchant Code"]; //alert(mcode);
                    var postData1 = {
                        mids: mids,
                        cids: cids,
                        sids: sids,
                        yestSend: fromdate,
                        todSend: todate,
                        acquirer_bank_code: bankID,
                        stateIds:stateIds,
                        cityids: cityids,
                        merchant_code: mcode
                    };

                    var content = '';
                    var loadingImg = "<div style='text-align: left'><img src=" + loadingGif + "></div>";
                    row.child(loadingImg).show();
                    $.ajax({
                        type: "POST",
                        data: postData1,
                        url:config.get('API_URL')+ "/reports/acq-reports-table-city-level",
                        beforeSend: function(request) {
                            request.setRequestHeader("Authorization", localStorage.usertoken);
                        },
                        success: function (data) {
                            content = '<table id="innerTableAcq" cellpadding="5" cellspacing="0" border="0" style="padding-left:0px; width:100%;">';
                            data.data.map((value, index) => {
                                // console.log("abccc");
                                // console.log(value["Billing Company Name"]);
                                content = content + '<tr>';
                                content = content + '<td style="width:20%">' + value["Merchant"] + ' </td>';
                                content = content + '<td style="width:10%">' + value["City"] + ' </td>';
                                content = content + '<td style="width:7%">' + value["Innoviti Store Count"] + ' </td>';
                                content = content + '<td style="width:7%">' + value["Bank Store Count"] + ' </td>';
                                content = content + '<td style="width:7%">' + value["Innoviti Terminal Count"] + ' </td>';
                                content = content + '<td style="width:7%">' + value["Bank Terminal Count"] + ' </td>';
                                content = content + '<td style="width:7%">' + value["Innoviti Card Volume"] + ' </td>';
                                content = content + '<td style="width:7%">' + value["Bank Card Volume"] + ' </td>';
                                content = content + '<td style="width:7%">' + value["Innoviti UPI Volume"] + ' </td>';
                                content = content + '<td style="width:7%">' + value["Bank UPI Volume"] + ' </td>';
                                content = content + '<td style="width:7%">' + value["Innoviti DCC Volume"] + ' </td>';
                                content = content + '<td style="width:7%">' + value["Innoviti DCC Volume"] + ' </td>';

                                content = content + '</tr>';
                            });
                            content = content + '</table>';
                            row.child(content,'no-padding').show();
                            tr.addClass('shown');
                            // var td = $(this).closest('tr');
                        },
                        error: function (data) {
                        },
                        complete: function () {

                        }
                    }).done(function () {
                        // printWithAjax();
                    });
                }

                $(this).closest('tr').find('.summary_plus').addClass('summary_minus');
                $(this).closest('tr').find('.summary_plus').removeClass('summary_plus');
            }
        });
    }
    changeMerchant(optionSelected){
        let value='';
        let midArray = [];
        if(optionSelected===null){
            value = null;
        }
        else{
            optionSelected.map((mids, i) => {
                midArray.push(mids.value)
                var index = this.state.merchantList.findIndex(obj => obj.value==mids.value);
                this.state.merchantList.move(index,0).join(',');
            });
        }
        this.setState({
            merchantID:midArray,
            chainID:'',
            merchantValue:optionSelected,
            chainValue:null
        });
        this._get_filtered_acq_report(midArray, this.state.chainID, this.state.storeID, this.state.acqBankIds,
            this.state.yestSend, this.state.todSend, this.state.cityIds, this.state.stateIds);
        this.getChain(midArray, 'merchant', this.state.object_type, this.state.object_code);
        this.getStore(midArray, 'merchant', this.state.object_type, this.state.object_code);

    }
    changeChain(optionSelected) {
        let value='';
        let cidArray = [];
        if(optionSelected==null){
            value = null;
        }
        else{
            optionSelected.map((cids, i) => {
                cidArray.push(cids.value)
                var index = this.state.chainList.findIndex(obj => obj.value==cids.value);
                this.state.chainList.move(index,0).join(',');
            });
        }
        this.setState({
            chainID: cidArray,
            chainValue:optionSelected
        });
        this._get_filtered_acq_report(this.state.merchantID, cidArray, this.state.storeID, this.state.acqBankIds,
            this.state.yestSend, this.state.todSend, this.state.cityIds, this.state.stateIds);

        if(this.state.object_type=='Innoviti'){
            this.getStore(cidArray, 'chain', this.state.object_type, this.state.merchantID);
        } else{
            this.getStore(cidArray, 'chain', this.state.object_type, this.state.object_code);
        }

    }
    getChain(code, type, object_type, object_code){
        axios.post(config.get('API_URL')+'/reports/get-chain/',{
                code: code,
                type: type,
                object_type: object_type,
                object_code: object_code
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

            }).then(response => {
            let chalinList = [];
            this.setState({chainID:''});
            response.data.map((chain,index) => {
                chalinList.push({value: chain.chain_code, label: chain.chain_name})
            });
            this.setState({
                chainList:chalinList
            })
        });
    }
    getStore(code, type, object_type, object_code) {
        axios.post(config.get('API_URL')+'/reports/get-store-filter/', {
                code: code,
                type: type,
                object_type: object_type,
                object_code: object_code
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }

            }).then(response => {
            let storeList = [];
            this.setState({storeID:''});
            response.data.map((store,index) => {
                storeList.push({value: store.store_code, label: store.store_name})
            });
            this.setState({
                storeList:storeList
            })
        });
    }
    changeStore(optionSelected) {
        let value='';
        let sidArray = [];
        if(optionSelected==null){
            value = null;
        }
        else{
            optionSelected.map((sids, i) => {
                sidArray.push(sids.value)
                var index = this.state.storeList.findIndex(obj => obj.value==sids.value);
                this.state.storeList.move(index,0).join(',');
            });
        }
        this.setState({
            storeID: sidArray,
            storeValue:optionSelected
        });

        this._get_filtered_acq_report(this.state.merchantID,this.state.chainID, sidArray, this.state.acqBankIds,
            this.state.yestSend, this.state.todSend, this.state.cityIds, this.state.stateIds);
    }
    _get_acq_banks(){
        axios.get(config.get('API_URL')+'/reports/acq-banks-report/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            var that = this;
            //  console.log("sdasdasdasdasdasd");
            // console.log(response.data.data);
            // console.log(Object.values(response.data.data)[7]);
            if(response.data.data) {
                this.setState({
                    acqBankValue: {
                        value: Object.values(response.data.data)[7],
                        label: Object.keys(response.data.data)[7]
                    }
                });
                this.setState({
                    acqBankIds: Object.values(response.data.data)[7]
                });
                Object.keys(response.data.data).map(function (key, i) {
                    that.state.acqBankList.push({value: response.data.data[key], label: key})
                });
                // response.data.data.map((acqBank,index) => {
                //     this.state.acqBankList.push({value: acqBank.acq_bank_code.toString(), label: acqBank.acq_bank_name})
                // });

                this._get_acq_report(this.state.yestSend, this.state.todSend, Object.values(response.data.data)[7]);
                this._get_filtered_acq_report(this.state.merchantID, this.state.chainID, this.state.storeID, Object.values(response.data.data)[7],
                    this.state.yestSend, this.state.todSend, this.state.cityIds, this.state.stateIds);
                this.get_acq_chart_reports(Object.values(response.data.data)[7], this.state.t_type);
            }
        });
        this.setState({
            loading:false
        })
    }
    change_acq_banks(optionSelected){
        const value = optionSelected === null ? '' : optionSelected.value;
        this.setState({
            acqBankIds:value,
            acqBankValue:optionSelected,
        });

        // this._get_filtered_acq_report(this.state.merchantID, this.state.chainID, this.state.storeID, acqBankArray, this.state.cityIds, this.state.frequency,
        //     this.state.yestSend, this.state.todSend, this.state.is_void);
        this._get_acq_report(this.state.yestSend, this.state.todSend, value);
        this._get_filtered_acq_report(this.state.merchantID, this.state.chainID, this.state.storeID, value,
            this.state.yestSend, this.state.todSend, this.state.cityIds, this.state.stateIds);
        this.get_acq_chart_reports(value, this.state.t_type);
    }
    get_acq_chart_reports(bankID, t_type){  //alert("hi")
            this.setState({
               // loading1:true,
                is_view_kpi: false,
                loading3: true
            });
            axios.post(config.get('API_URL')+'/reports/get-acq-charts-reports/',{
                    acquirer_bank_code: bankID,
                    t_type: t_type

                },
                {
                    headers: {
                        Authorization: ` ${localStorage.usertoken}`
                    },

                }).then(response => {
                // console.log("jdsfgsdhfghsdfsd");
                // console.log(response.data);
                    var transaction_volume_month =[];
                    var transaction_volume = [];
                    var transaction_merchant_month= [];
                    var transaction_merchant = [];
                    var transaction_volume_month_credit= [];
                    var transaction_volume_credit = [];
                    var transaction_volume_month_debit= [];
                    var transaction_volume_debit = [];
                    var transaction_volume_month_dcc= [];
                    var transaction_volume_dcc = [];
                    var transaction_volume_month_upi= [];
                    var transaction_volume_upi = [];
                if(t_type=='percentage') {
                    response.data.volume_data.map((val, index) => {
                        var month = '';
                        if (val.Month == '01' || val.Month == '1') {
                            month = 'January';
                        } else if (val.Month == '02' || val.Month == '2') {
                            month = 'February';
                        } else if (val.Month == '03' || val.Month == '3') {
                            month = 'March';
                        } else if (val.Month == '04' || val.Month == '4') {
                            month = 'April';
                        } else if (val.Month == '05' || val.Month == '5') {
                            month = 'May';
                        } else if (val.Month == '06' || val.Month == '6') {
                            month = 'June';
                        } else if (val.Month == '07' || val.Month == '7') {
                            month = 'July';
                        } else if (val.Month == '08' || val.Month == '8') {
                            month = 'Agust';
                        } else if (val.Month == '09' || val.Month == '9') {
                            month = 'September';
                        } else if (val.Month == '10') {
                            month = 'October';
                        } else if (val.Month == '11') {
                            month = 'November';
                        } else if (val.Month == '12') {
                            month = 'December';
                        }
                        if (val["Measure Name"] == 'transaction_volume') {
                            transaction_volume_month.push(month + '-' + val.Year);
                            transaction_volume.push(val.Volume);
                            this.setState({
                                is_vol: true,
                            })
                        } else {
                            this.setState({
                                is_vol: false,
                            })
                        }
                        if (val["Measure Name"] == 'transaction_volume_credit') {
                            transaction_volume_month_credit.push(month + '-' + val.Year);
                            transaction_volume_credit.push(val.Volume);
                            this.setState({
                                is_credit_vol: true,
                            })
                        } else {
                            this.setState({
                                is_credit_vol: false,
                            })
                        }
                        if (val["Measure Name"] == 'transaction_volume_debit') {
                            transaction_volume_month_debit.push(month + '-' + val.Year);
                            transaction_volume_debit.push(val.Volume);
                            this.setState({
                                is_debit_vol: true,
                            })
                        } else {
                            this.setState({
                                is_debit_vol: false,
                            })
                        }
                        if (val["Measure Name"] == 'transaction_volume_upi') {
                            transaction_volume_month_upi.push(month + '-' + val.Year);
                            transaction_volume_upi.push(val.Volume);
                            this.setState({
                                is_upi_vol: true,
                            })
                        } else {
                            this.setState({
                                is_upi_vol: false,
                            })
                        }
                        if (val["Measure Name"] == 'transaction_volume_emi') {
                            transaction_volume_month_dcc.push(month + '-' + val.Year);
                            transaction_volume_dcc.push(val.Volume);
                            this.setState({
                                is_dcc_vol: true,
                            })
                        } else {
                            this.setState({
                                is_dcc_vol: false,
                            })
                        }
                    });
                }
                else {
                    response.data.bank_volume_data.map((val, index) => {
                        var month = '';
                        if (val.Month == '01' || val.Month == '1') {
                            month = 'January';
                        } else if (val.Month == '02' || val.Month == '2') {
                            month = 'February';
                        } else if (val.Month == '03' || val.Month == '3') {
                            month = 'March';
                        } else if (val.Month == '04' || val.Month == '4') {
                            month = 'April';
                        } else if (val.Month == '05' || val.Month == '5') {
                            month = 'May';
                        } else if (val.Month == '06' || val.Month == '6') {
                            month = 'June';
                        } else if (val.Month == '07' || val.Month == '7') {
                            month = 'July';
                        } else if (val.Month == '08' || val.Month == '8') {
                            month = 'Agust';
                        } else if (val.Month == '09' || val.Month == '9') {
                            month = 'September';
                        } else if (val.Month == '10') {
                            month = 'October';
                        } else if (val.Month == '11') {
                            month = 'November';
                        } else if (val.Month == '12') {
                            month = 'December';
                        }
                        if (val["Measure Name"] == 'transaction_volume') {
                            transaction_volume_month.push(month + '-' + val.Year);
                            transaction_volume.push(val.Volume);
                            this.setState({
                                is_vol: true,
                            })
                        } else {
                            this.setState({
                                is_vol: false,
                            })
                        }
                        if (val["Measure Name"] == 'transaction_volume_credit') {
                            transaction_volume_month_credit.push(month + '-' + val.Year);
                            transaction_volume_credit.push(val.Volume);
                            this.setState({
                                is_credit_vol: true,
                            })
                        } else {
                            this.setState({
                                is_credit_vol: false,
                            })
                        }
                        if (val["Measure Name"] == 'transaction_volume_debit') {
                            transaction_volume_month_debit.push(month + '-' + val.Year);
                            transaction_volume_debit.push(val.Volume);
                            this.setState({
                                is_debit_vol: true,
                            })
                        } else {
                            this.setState({
                                is_debit_vol: false,
                            })
                        }
                        if (val["Measure Name"] == 'transaction_volume_upi') {
                            transaction_volume_month_upi.push(month + '-' + val.Year);
                            transaction_volume_upi.push(val.Volume);
                            this.setState({
                                is_upi_vol: true,
                            })
                        } else {
                            this.setState({
                                is_upi_vol: false,
                            })
                        }
                        if (val["Measure Name"] == 'transaction_volume_emi') {
                            transaction_volume_month_dcc.push(month + '-' + val.Year);
                            transaction_volume_dcc.push(val.Volume);
                            this.setState({
                                is_dcc_vol: true,
                            })
                        } else {
                            this.setState({
                                is_dcc_vol: false,
                            })
                        }
                    });
                }
                response.data.bank_merchant_data.map((val,index) => {
                    var month = '';
                    if(val.Month=='01' || val.Month=='1') {
                        month = 'January';
                    } else if(val.Month=='02' || val.Month=='2'){
                        month = 'February';
                    }else if(val.Month=='03' || val.Month=='3'){
                        month = 'March';
                    }else if(val.Month=='04' || val.Month=='4'){
                        month = 'April';
                    }else if(val.Month=='05' || val.Month=='5'){
                        month = 'May';
                    }else if(val.Month=='06' || val.Month=='6'){
                        month = 'June';
                    }else if(val.Month=='07' || val.Month=='7'){
                        month = 'July';
                    }else if(val.Month=='08' || val.Month=='8'){
                        month = 'Agust';
                    }else if(val.Month=='09' || val.Month=='9'){
                        month = 'September';
                    }else if(val.Month=='10'){
                        month = 'October';
                    }else if(val.Month=='11'){
                        month = 'November';
                    }else if(val.Month=='12'){
                        month = 'December';
                    }
                        transaction_merchant_month.push(month+'-'+val.Year);
                        transaction_merchant.push(val.cnt);
                        // transaction_merchant_month.reverse();
                        // transaction_merchant.reverse();
                    this.setState({
                        is_merchant_per: true,
                    })
                });
                if(t_type=='percentage') { //alert(t_type);
                    transaction_merchant =[];
                    response.data.innoviti_merchant_data.map((val,index) => {
                        //alert(response.data.bank_merchant_data[index].cnt);
                        var tm = response.data.bank_merchant_data[index].cnt*100/val.cnt;
                        tm = tm.toFixed(2);
                        transaction_merchant.push(tm);
                        this.setState({
                        is_merchant_per: true,
                    })
                });
                }
                //    console.log("transaction merchant");
                // console.log(transaction_volume);
                // console.log(transaction_volume_month);
                    this.get_merchant_small_chart(transaction_volume, transaction_volume_month, 'Volume');
                    this.get_merchant_small_chart(transaction_merchant, transaction_merchant_month, 'Merchant');
                    this.get_merchant_small_chart(transaction_volume_credit, transaction_volume_month_credit, 'Credit Volume');
                    this.get_merchant_small_chart(transaction_volume_debit, transaction_volume_month_debit, 'Debit Volume');
                    this.get_merchant_small_chart(transaction_volume_upi, transaction_volume_month_upi, 'UPI Volume');
                    this.get_merchant_small_chart(transaction_volume_dcc, transaction_volume_month_dcc, 'DCC Volume');
                this.setState({
                    // loading1:true,
                    is_view_kpi: true,
                    loading3: false
                });

                })


    }
    _get_city(states_names){
        axios.post(config.get('API_URL')+'/reports/get-city-acq/', {
                states_names:states_names
            },
            {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            response.data.map((city,index) => {
                this.state.cityLists.push({value: city.city_name, label: city.city_name})
            });
        });
        this.setState({
            loading:false
        })
    }

    changeCity(optionSelected) { //console.log(optionSelected);
        let value='';
        let cityArray = [];
        if(optionSelected===null){
            value = null;
        }
        else{
            optionSelected.map((mids, i) => {
                cityArray.push(mids.value)
            });
        }
        this.setState({
            cityIds:cityArray,
            cityValue:optionSelected,
        });
        this._get_filtered_acq_report(this.state.merchantID,this.state.chainID, this.state.storeID, this.state.acqBankIds,
            this.state.yestSend, this.state.todSend, cityArray, this.state.stateIds);
    }
    change_t_Type(t_type, e) {
        this.setState({
            t_type:t_type
        });
        this.get_acq_chart_reports(this.state.acqBankIds, t_type);
    }
    _get_states(){
        axios.get(config.get('API_URL')+'/reports/get-states/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            response.data.map((state,index) => {
                this.state.stateLists.push({value: state.state_name, label: state.state_name})
            });
        });
        this.setState({
            loading:false
        })
    }
    changeState(optionSelected){
        let value='';
        let staArray = [];
        if(optionSelected===null){
            value = null;
        }
        else{
            optionSelected.map((mids, i) => {
                staArray.push(mids.value)
            });
        }

        this.setState({
            stateIds:staArray,
            cityID:'',
            stateValue:optionSelected,
            cityValue:null,
            cityLists:[]
        });
        this._get_filtered_acq_report(this.state.merchantID,this.state.chainID, this.state.storeID, this.state.acqBankIds,
            this.state.yestSend, this.state.todSend, this.state.cityIds, staArray);
        this._get_city(staArray);
    }
    // get_invoice_history(){
    //     axios.get(config.get('API_URL')+'/invoice/invoice-history/', {
    //         headers: {
    //             Authorization: ` ${localStorage.usertoken}`
    //         },
    //     }).then(response => {
    //         console.log(response);
    //         var labels = [];
    //         var month_val = [];
    //         var bColor = [];
    //         response.data.data.map((value, index) => {
    //             if(this.state.label_month==value['For Month']) {
    //                 bColor.push('#008cdd')
    //             } else {
    //                 bColor.push('#1DC7EA')
    //             }
    //             labels.push(value['For Month']);
    //             month_val.push(value['Invoice Amount']);
    //
    //         })
    //         console.log(labels);
    //         var data = {
    //             labels: labels,
    //             datasets: [
    //                 {
    //                     label: 'Invoice History',
    //                     backgroundColor: bColor,
    //                     borderColor: '#008cdd',
    //                     borderWidth: 1,
    //                     hoverBackgroundColor: '#008cdd',
    //                     hoverBorderColor: '#1DC7EA',
    //                     data: month_val
    //                 }
    //             ]
    //         };
    //         this.setState({
    //             invoice_history_data :data,
    //             invoice_history:response.data,
    //         });
    //
    //     }).catch(err => {
    //         console.log(err);
    //     });
    // }
    // createLegend(json) {
    //     var legend = [];
    //     for (var i = 0; i < json["names"].length; i++) {
    //         var type = "fa fa-circle text-" + json["types"][i];
    //         legend.push(<i className={type} key={i} />);
    //         legend.push(" ");
    //         legend.push(json["names"][i]);
    //     }
    //     return legend;
    // }
    render() {
        const MenuList = props => {
            const rows = props.children;
            let no_of_rows = 0;
            let drop_down_heigth = 0
            if(rows.length!== undefined){
                no_of_rows = rows.length;
                if(no_of_rows<9) {drop_down_heigth = 40*no_of_rows;}
                else{
                    drop_down_heigth = 300;
                }

            }
            const rowRenderer = ({ key, index, isScrolling, isVisible, style }) => (
                <div key={key} style={style}>{rows[index]}</div>
            );

            return (
                <List
                    style={{ width: '100%' }}
                    width={300}
                    height={drop_down_heigth}
                    rowHeight={30}
                    rowCount={no_of_rows}
                    rowRenderer={rowRenderer}
                />
            )
        }
        const customStyles = {
            control: provided => ({
                ...provided,
                padding:"0px",
                minHeight: "15px",
            }),
            indicatorsContainer: provided => ({
                ...provided,
                height: "23px"
            }),
            clearIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            dropdownIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            valueContainer: base => ({
                ...base,
                padding: '0px 6px'
            }),
            menu: styles => ({ ...styles, zIndex: 999 })

        };

        var vcls = "btn btn-sm btn-default switchVolumn";
        var ccls = "btn btn-sm btn-default switchVolumn";
        if(this.state.t_type=='absolute' ) {
            vcls = "btn btn-sm btn-primary switchVolumn";
            ccls = "btn btn-sm btn-default switchVolumn";
        }
        if(this.state.t_type=='percentage' ) {
            vcls = "btn btn-sm btn-default switchVolumn";
            ccls = "btn btn-sm btn-primary switchVolumn";
        }
        return (

            <div className="content">
                <div className="container-fluid">
                    <div className="row top10">
                        <div className="col-lg-4 col-sm-6">
                            <div>

                            <label>Select Date Range </label>
                            <DateRangePicker startDate={this.state.datefrom} endDate={this.state.dateTo} onEvent={this.handleEvent.bind(this)}>
                                <i class="fa fa-calendar" aria-hidden="true"></i>
                                <input type="text" name="dateRange" className="form-control dateRangeInput" value={this.state.datefromShow+' - '+this.state.dateToShow}/>
                            </DateRangePicker>
                            </div>
                            <div className="gap_ver"></div>
                            <div>
                                <Select name="acqurier"
                                        value={this.state.acqBankValue}
                                        styles={customStyles} className="report-listbox"
                                        isClearable={false}
                                        onChange={this.change_acq_banks.bind(this)}
                                        options={this.state.acqBankList}
                                        //defaultValue={{ label: "Select Dept", value: 0 }}
                                       // placeholder="Select [Acquirer]"
                                />
                            </div>
                            <div className="clearfix"></div>
                        </div>
                        <div className="col-lg-8 col-sm-6">
                            <div className="card card-stats bottom0">
                                <div className="content">
                                    <div className="row fixHight">
                                        {this.state.is_view_report===true ?
                                            <div
                                                className="content-tdetails-table table-full-width table-responsive marginTop0">
                                                <table id="AcqReport_Table" className="table table-striped table-hover">
                                                    <thead>
                                                    <tr>
                                                        <th></th>
                                                        <th>Innoviti Base</th>
                                                        <th>Acquiring Bank</th>
                                                        <th>%</th>

                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr>
                                                        <td>Total Store Count</td>
                                                        <td>{formatNumber(this.state.inno_store_count)}</td>
                                                        <td>{formatNumber(this.state.acq_store_count)}</td>
                                                        <td>{this.state.count_per}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Total credit card volume(INR)</td>
                                                        <td>{formatNumber(this.state.inno_transaction_vol_credit)}</td>
                                                        <td>{formatNumber(this.state.acq_transaction_vol_credit)}</td>
                                                        <td>{this.state.credit_per}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Total debit card volume(INR)</td>
                                                        <td>{formatNumber(this.state.inno_transaction_vol_debit)}</td>
                                                        <td>{formatNumber(this.state.acq_transaction_vol_debit)}</td>
                                                        <td>{this.state.debit_per}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>UPI volume(INR)</td>
                                                        <td>{formatNumber(this.state.inno_transaction_vol_upi)}</td>
                                                        <td>{formatNumber(this.state.acq_transaction_vol_upi)}</td>
                                                        <td>{this.state.upi_per}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>EMI volume(INR)</td>
                                                        <td>{formatNumber(this.state.inno_transaction_vol_dcc)}</td>
                                                        <td>{formatNumber(this.state.acq_transaction_vol_dcc)}</td>
                                                        <td>{(this.state.dcc_per)}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Transction volume(INR)</td>
                                                        <td>{formatNumber(this.state.inno_transaction_vol)}</td>
                                                        <td>{formatNumber(this.state.acq_transaction_vol)}</td>
                                                        <td>{this.state.vol_per}</td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div> :
                                            <BeatLoader
                                                css={override}
                                                sizeUnit={"px"}
                                                size={20}
                                                color={'#123abc'}
                                                loading={this.state.loading1}
                                            />
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-xs-4 pull-left">
                            <div className="">
                                <div className="btn-group">
                                    <button className={vcls} type="button" value="volume" onClick={this.change_t_Type.bind(this,'absolute')}>Abs </button>
                                    <button className={ccls} type="button" value="count" onClick={this.change_t_Type.bind(this,'percentage')}>% </button>
                                </div>
                            </div>
                        </div>
                        <div className="clearfix"></div>
                        {/*{this.state.is_merchant_per?*/}
                        <div className="col-md-2">
                            <div className="card">
                                <div className="AcqChartTitle">Merchants</div>
                                <div className="content">
                                    {this.state.is_view_kpi===true?
                                    <Line
                                        data={this.state.merchant_chart_data}
                                        options={{
                                            legend: {
                                                display: false
                                            },
                                            scales: {
                                                yAxes: [{
                                                    ticks: {
                                                        display: false
                                                    }
                                                }],
                                                xAxes: [{
                                                    ticks: {
                                                        display: false
                                                    }
                                                }],

                                            },
                                            tooltips: toolTipConfig,
                                            maintainAspectRatio: false
                                        }}
                                        // width={50}
                                         height={50}
                                        // options={{
                                        //     maintainAspectRatio: false
                                        // }}
                                    />:<BeatLoader
                                        css={override}
                                        sizeUnit={"px"}
                                        size={10}
                                        color={'#123abc'}
                                        loading={this.state.loading3}
                                    />}

                                </div>
                            </div>
                        </div>
                            {/*: null }*/}
                        {/*{this.state.is_vol?*/}
                        <div className="col-md-2">
                            <div className="card">
                                <div className="AcqChartTitle">Volume{this.state.t_type == 'absolute' ?
                                    <span>(In K)</span> : null}</div>
                                <div className="content">
                                    {this.state.is_view_kpi===true?
                                    <Line
                                        data={this.state.volume_chart_data}
                                        options={{
                                            legend: {
                                                display: false
                                            },
                                            scales: {
                                                yAxes: [{
                                                    ticks: {
                                                        display: false
                                                    }
                                                }],
                                                xAxes: [{
                                                    ticks: {
                                                        display: false
                                                    }
                                                }]
                                            },
                                            tooltips: toolTipConfig,
                                            maintainAspectRatio: false
                                        }}
                                        // width={50}
                                        height={50}
                                        // options={{
                                        //     maintainAspectRatio: false
                                        // }}
                                    />:<BeatLoader
                                            css={override}
                                            sizeUnit={"px"}
                                            size={10}
                                            color={'#123abc'}
                                            loading={this.state.loading3}
                                        />}

                                </div>
                            </div>
                        </div>
                        {/*: null }*/}
                        {/*{this.state.is_credit_vol?*/}
                        <div className="col-md-2">
                            <div className="card">
                                <div className="AcqChartTitle">Credit Card Volume{this.state.t_type == 'absolute' ?
                                    <span>(In K)</span> : null}</div>
                                <div className="content">
                                    {this.state.is_view_kpi===true?
                                    <Line
                                        data={this.state.cr_vol_chart_data}
                                        options={{
                                            legend: {
                                                display: false
                                            },
                                            scales: {
                                                yAxes: [{
                                                    ticks: {
                                                        display: false
                                                    }
                                                }],
                                                xAxes: [{
                                                    ticks: {
                                                        display: false
                                                    }
                                                }]
                                            },
                                            tooltips: toolTipConfig,
                                            maintainAspectRatio: false
                                        }}
                                        // width={50}
                                        height={50}
                                        // options={{
                                        //     maintainAspectRatio: false
                                        // }}
                                    />:<BeatLoader
                                    css={override}
                                    sizeUnit={"px"}
                                    size={10}
                                    color={'#123abc'}
                                    loading={this.state.loading3}
                                />}

                                </div>
                            </div>
                        </div>
                            {/*// : null }*/}
                        {/*{this.state.is_debit_vol?*/}
                        <div className="col-md-2">
                            <div className="card">
                                <div className="AcqChartTitle">Debit Card Volume{this.state.t_type == 'absolute' ?
                                    <span>(In K)</span> : null}</div>
                                <div className="content">
                                    {this.state.is_view_kpi===true?
                                    <Line
                                        data={this.state.deb_vol_chart_data}
                                        options={{
                                            legend: {
                                                display: false
                                            },
                                            scales: {
                                                yAxes: [{
                                                    ticks: {
                                                        display: false
                                                    }
                                                }],
                                                xAxes: [{
                                                    ticks: {
                                                        display: false
                                                    }
                                                }]
                                            },
                                            tooltips: toolTipConfig,
                                            maintainAspectRatio: false
                                        }}
                                        // width={50}
                                        height={50}
                                        // options={{
                                        //     maintainAspectRatio: false
                                        // }}
                                    />:<BeatLoader
                                    css={override}
                                    sizeUnit={"px"}
                                    size={10}
                                    color={'#123abc'}
                                    loading={this.state.loading3}
                                />}

                                </div>
                            </div>
                        </div>
                        {/*: null }*/}
                        {/*{this.state.is_upi_vol?*/}
                        <div className="col-md-2">
                            <div className="card">
                                <div className="AcqChartTitle">UPI Volume{this.state.t_type == 'absolute' ?
                                    <span>(In K)</span> : null}</div>
                                <div className="content">
                                    {this.state.is_view_kpi===true?
                                    <Line
                                        data={this.state.upi_vol_chart_data}
                                        options={{
                                            legend: {
                                                display: false
                                            },
                                            scales: {
                                                yAxes: [{
                                                    ticks: {
                                                        display: false
                                                    }
                                                }],
                                                xAxes: [{
                                                    ticks: {
                                                        display: false
                                                    }
                                                }]
                                            },
                                            tooltips: toolTipConfig,
                                            maintainAspectRatio: false
                                        }}
                                        // width={50}
                                        height={50}
                                        // options={{
                                        //     maintainAspectRatio: false
                                        // }}
                                    />:<BeatLoader
                                    css={override}
                                    sizeUnit={"px"}
                                    size={10}
                                    color={'#123abc'}
                                    loading={this.state.loading3}
                                />}

                                </div>
                            </div>
                        </div>

                        <div className="col-md-2">
                            <div className="card">
                                <div className="AcqChartTitle">EMI Volume{this.state.t_type == 'absolute' ?
                                    <span>(In K)</span> : null}</div>
                                <div className="clearfix"></div>
                                <div className="content">
                                    {this.state.is_view_kpi===true?
                                    <Line
                                        data={this.state.dcc_vol_chart_data}
                                        options={{
                                            legend: {
                                                display: false
                                            },
                                            scales: {
                                                yAxes: [{
                                                    ticks: {
                                                        display: false
                                                    }
                                                }],
                                                xAxes: [{
                                                    ticks: {
                                                        display: false
                                                    }
                                                }]
                                            },
                                            tooltips: toolTipConfig,
                                            maintainAspectRatio: false
                                        }}
                                        // width={50}
                                        height={50}
                                        // options={{
                                        //     maintainAspectRatio: false
                                        // }}
                                    />:<BeatLoader
                                    css={override}
                                    sizeUnit={"px"}
                                    size={10}
                                    color={'#123abc'}
                                    loading={this.state.loading3}
                                />}

                                </div>
                            </div>
                        </div>


                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="">
                                    <div className="col-md-3">
                                        <label>Merchants</label>
                                        <ReactMultiSelectCheckboxes name="merchants"
                                                isMulti
                                                value={this.state.merchantValue}
                                                styles={customStyles} className="report-listbox"
                                                isClearable={false}
                                                onChange={this.changeMerchant.bind(this)}
                                                options={this.state.merchantList}
                                                placeholderButtonLabel="Select [Merchant]"
                                        />

                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="col-md-3">
                                        <label> Chain </label>
                                        <ReactMultiSelectCheckboxes name="chain"
                                                isMulti
                                                components={{ MenuList }}
                                                value={this.state.chainValue}
                                                styles={customStyles} className="report-listbox"
                                                isClearable={false}
                                                onChange={this.changeChain.bind(this)}
                                                options={this.state.chainList}
                                                placeholderButtonLabel="Select [Chain]"
                                        />
                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="col-md-2">
                                        <label> Store </label>
                                        <ReactMultiSelectCheckboxes name="store"
                                                isMulti
                                                components={{ MenuList }}
                                                value={this.state.storeValue}
                                                styles={customStyles} className="report-listbox"
                                                isClearable={false}
                                                onChange={this.changeStore.bind(this)}
                                                options={this.state.storeList}
                                                placeholderButtonLabel="Select [Store]"
                                        />
                                        <div className="clearfix"></div>
                                    </div>
                                    {/*<div className="col-md-2">*/}
                                    {/*    <label>Ho State</label>*/}
                                    {/*    <Select name="State"*/}
                                    {/*            isMulti*/}
                                    {/*            value={this.state.stateValue}*/}
                                    {/*            styles={customStyles} className="report-listbox"*/}
                                    {/*            isClearable={false}*/}
                                    {/*            onChange={this.changeState.bind(this)}*/}
                                    {/*            options={this.state.stateLists}*/}
                                    {/*            placeholder="Select [State]"*/}
                                    {/*    />*/}
                                    {/*</div>*/}
                                    {/*<div className="col-md-2">*/}
                                    {/*    <label>Ho City</label>*/}
                                    {/*    <Select name="city"*/}
                                    {/*            isMulti*/}
                                    {/*            value={this.state.cityValue}*/}
                                    {/*            styles={customStyles} className="report-listbox"*/}
                                    {/*            isClearable={false}*/}
                                    {/*            onChange={this.changeCity.bind(this)}*/}
                                    {/*            options={this.state.cityLists}*/}
                                    {/*            placeholder="Select [City]"*/}
                                    {/*    />*/}
                                    {/*</div>*/}
                                    <div className="clearfix"></div>
                                </div>
                                <div className="clearfix"></div>
                                <div className="gap_ver"></div>
                                <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                    <table id="AcqReportVol" className="table table-striped table-hover">
                                        <thead>
                                        <tr>
                                            <th rowspan="2">Merchant</th>
                                            <th rowspan="2">City</th>
                                            <th colSpan="2" className="centerAlign">Store Count</th>
                                            <th colSpan="2" className="centerAlign">Terminal Count</th>
                                            <th colSpan="2" className="centerAlign">Card Volume</th>
                                            <th colSpan="2" className="centerAlign">UPI Volume</th>
                                            <th colSpan="2" className="centerAlign">DCC Volume</th>
                                        </tr>
                                        <tr>
                                            <th>Innoviti</th>
                                            <th>Bank</th>
                                            <th>Innoviti</th>
                                            <th>Bank</th>
                                            <th>Innoviti</th>
                                            <th>Bank</th>
                                            <th>Innoviti </th>
                                            <th>Bank</th>
                                            <th>Innoviti</th>
                                            <th>Bank</th>
                                        </tr>
                                        </thead>
                                        <tbody>

                                        </tbody>
                                    </table>
                                    <br/><br/>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

             );
    }
}

const mapDispatchToProps = (dispatch) =>{
  return {
  currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
  }
}
export default connect(null,mapDispatchToProps)(AcquirerReport);
